<div class="ui-page-title flex" [ngClass]="{ 'modal-title-wrapper': showModalHeader, 'modal-title-without-showmore': !showMore && showModalHeader }">
    <div [ngClass]="titleClass ? titleClass : 'col-8'" class="flex align-items-center grid-nogutter pl-0">
        <ng-container *ngIf="showBack">
            <button [id]="pageCode + '_back_button'" pButton (click)="goBack()" class="p-button back-button p-button-icon-only p-button-text mr-2">
                <i class="material-icons big-icon"> arrow_back </i>
            </button>
        </ng-container>
        <h3 title="{{ title }}" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
            <span *ngIf="widget" class="app-icon material-icons big-icon">apps</span> {{ title }}<span *ngIf="titleDetail" class="font-italic font-light">{{ ': ' + titleDetail }}</span>
        </h3>
    </div>
    <div class="col" style="text-align: right">

        <button [id]="pageCode + '_redirect_button'" *ngIf="showRedirect" pButton #btn (click)="redirect()" class="p-button p-button-text btn-icon-only">
            <i class="material-icons">arrow_forward_ios</i>
        </button>
    </div>
    <!-- <div class="header-border-wrapper" *ngIf="showModalHeader">
        <hr />
    </div> -->
</div>
